import { MessageService } from 'src/app/features/dfte-grid-view/services/message.service';
import { Component, OnInit } from '@angular/core';

import { Observable } from 'rxjs';

@Component({
  selector: 'app-overlay-message',
  templateUrl: './overlay-message.component.html',
  styleUrls: ['./overlay-message.component.scss']
})
export class OverlayMessageComponent implements OnInit {
  message$: Observable<string>;
  type$: Observable<'success' | 'error' | 'info' | 'warning'>;
  isVisible$: Observable<boolean>;

  constructor(private messageService: MessageService) {}

  ngOnInit() {
    this.message$ = this.messageService.message$;
    this.type$ = this.messageService.type$;
    this.isVisible$ = this.messageService.visibility$;
  }
}
